import React from 'react'
import Navbar from './Components/Navbar/Navbar'
import { Routes,Route} from 'react-router-dom';
import Home from './Pages/Home/Home';
import Footer from './Components/Footer/Footer';


const App = () => {
  return (
    <div className='app'>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>}/>
      </Routes>
      {/* <Home/>
      <Coin/> */}
      <Footer/>
    </div>
  )
}

export default App